import AboutUs1 from "./sections/AboutUs1";
import AboutUs2 from "./sections/AboutUs2";
import Banner from "./sections/PageBanner";
import Footer from "./sections/PageFooter";
import PageHeader from "./sections/PageHeader";

export default function AboutUs(){
    return (
        <>
        <Banner />
        <PageHeader />
        <AboutUs1 />
        <AboutUs2 />
        <Footer />
        </>
    )
}